export function getOrderNavigationUrl({
  fulfillmentGroupId,
  orderId,
  ordersOutboundLabelsHref,
  sourceView,
}: {
  fulfillmentGroupId: string;
  orderId: { id: string } | { redoOrderId: string };
  ordersOutboundLabelsHref: string;
  sourceView?: string;
}): string {
  const sourceViewParam = sourceView
    ? `&sourceView=${encodeURIComponent(sourceView)}`
    : "";

  return "redoOrderId" in orderId
    ? `${ordersOutboundLabelsHref}/orders/${orderId.redoOrderId}?outboundOrderTab=${fulfillmentGroupId}&isRedoOrder=true${sourceViewParam}`
    : `${ordersOutboundLabelsHref}/orders/${btoa(orderId.id)}?outboundOrderTab=${fulfillmentGroupId}&isRedoOrder=false${sourceViewParam}`;
}
